// extracted by mini-css-extract-plugin
export default {"root":"SioM1mjtFWUBN2wFXQL2"};